
import StageManager from "../../../../../shared/lib/html5-software-library/src/ranj/performance/StageManager";
import Task from "../../../../../shared/lib/html5-software-library/src/ranj/util/executor/Task";
import { isNull } from "../../../../../shared/lib/html5-software-library/src/ranj/util/TypeUtil";
import { applySearchParametersToObject, getURLParameter } from "../../../../../shared/lib/html5-software-library/src/ranj/util/URLUtil";
import AssetLibrary from "../../../../../shared/src/ranj/app/assetloading/AssetLibrary";
import AppModel from "../../../../../shared/src/ranj/app/core/AppModel";
import SaveEvent from "../../../../../shared/src/ranj/equalture/savegame/SaveEvent";
import GameConfig from "../model/GameConfig";
import GameModel from "../model/GameModel";
import GameElementSkinFactory from "../view/GameElementSkinFactory";

export default class InitAccuracyGameTask extends Task {

    /**
     * @param {AssetLibrary} assetLibrary 
     * @param {GameConfig} gameConfig 
     * @param {GameModel} gameModel 
     * @param {StageManager} stageManager
     */
    constructor(dispatcher, assetLibrary, gameConfig, gameModel, levelAssets, stageManager) {
        super();

        this.execute = function(callback, progressCallback) {

            if (AppModel.isMobile) {
                stageManager.setAllStagesFramerate(30);
            }

            var configJSON = assetLibrary.getAsset("gameConfig");
            if (ranj.DEBUG) {
                applySearchParametersToObject(window.top.location.search, configJSON);
                window.document.addEventListener("keyup", this._handleKeyUp);
            }
            gameConfig.setPropertiesFromObject(configJSON);

            gameModel.initialize();
            const lvl = parseInt(getURLParameter("level"));
            if (!isNaN(lvl)) {
                gameModel._puzzleIndex = Math.max(lvl - 2, -1);
            }

            if (ranj.DEBUG) {
                window.gameconfig = gameConfig;
                window.gamemodel = gameModel;

                const n = parseInt(getURLParameter("generate"));
                if (!isNaN(n)) {
                    const elementFactory = new GameElementSkinFactory(gameConfig, levelAssets);
                    this.generatePuzzles(gameConfig, elementFactory, n);
                }
            }

            callback(this);
        }

        this._handleKeyUp = function(e) {
            const c = String.fromCharCode(e.which);
            if (c == "R") {
                if (confirm("Are you sure you want to reset the savegame?")) {
                    dispatcher.dispatch(SaveEvent.CLEAR);
                    window.location.reload();
                }
            }
        }.bind(this);


        document.addEventListener("visibilitychange", _ => {
            console.log("Event: visibilitychange. Hidden: " + document.hidden);
            createjs.Ticker.paused = document.hidden;
        });
    }


    generatePuzzles(gameConfig, elementFactory, n = 30) {
        const matches = gameConfig.getValue("generate.matches");
        const poolSize = gameConfig.getValue("generate.poolSize");
        const visibleMatches = gameConfig.getValue("generate.visibleMatches");//possible nrs of matches in initial viewport
        const locations = gameConfig.getValue("locations");
        const firstTarget = gameConfig.getValue("tutorial").puzzle.target;
        const itemPool = [];
        const itemCount = gameConfig.getValue("items").length;
        for (let i = 0; i < itemCount; i++) itemPool.push(i);

        const puzzles = [];
        for (let i = 0; i < n; i++) {
            //rotate through locations
            const locationIndex = i % locations.length;
            const location = locations[locationIndex];
            const locationSkin = elementFactory.getLocation(locationIndex);
            locationSkin.gotoAndStop(0);
            const slotCount = locationSkin.children.filter(child => child.name.indexOf("slot") == 0).length;
            //Slots which are in initial viewport:
            const visibleSlots = location.visibleSlots;
            //Use `poolSize` different items in puzzle:
            const pool = ArrayUtil.shuffle(itemPool.slice(0)).slice(0, poolSize);
            //Determine puzzle features:
            const visibleMatchCount = Math.min(pick(visibleMatches), visibleSlots.length);
            const matchCount = pick(matches) - visibleMatchCount;
            const match = i == 0 ? firstTarget : pool.pop();
            //Assign items to slots
            const items = [];
            //  First make sure there are N matches in initial viewport:
            //  fill visible slots randomly, then overwrite N slots with match            
            ArrayUtil.shuffle(visibleSlots);
            visibleSlots.forEach((slotIndex, index) => {
                if (index < visibleMatchCount) {
                    items[slotIndex] = match;
                } else {
                    items[slotIndex] = pick(pool);
                }
            });
            //Fill other slots (outside initial viewport)
            const slotsOther = [];
            for (let j = 0; j < slotCount; j++) {
                if (visibleSlots.indexOf(j)==-1) {
                    slotsOther.push(j);
                }
            }
            ArrayUtil.shuffle(slotsOther);
            slotsOther.forEach((slotIndex, index) => {
                if (index < matchCount) {
                    items[slotIndex] = match;
                } else {
                    items[slotIndex] = pick(pool);
                }
            });
            
            puzzles.push({
                location: locations.indexOf(location),
                target: match,
                count: matchCount,
                items: items
            });
        }
        console.log(JSON.stringify(puzzles));
        gameConfig._data.puzzles = puzzles;
    }

}

const pick = function(pool) {
    return pool[Math.floor(Math.random() * pool.length)];
}

const ArrayUtil = {};
ArrayUtil.shuffle = function(a) {
    let j, x, i;
    for (i = a.length; i; i--) {
        j = Math.floor(Math.random() * i);
        x = a[i - 1];
        a[i - 1] = a[j];
        a[j] = x;
    }
    return a;
}